import Battles from "./Battles";

export default Battles;
